export const logout = () => (dispatch, getState, { api }) => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  window.location.reload();

}